export { default } from './ModalNoLogat';
